var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-over"},[_c('h2',[_vm._v("Game Over")]),_c('div',[_vm._v("Try again")]),_c('button',{on:{"click":_vm.makeInitialMap}},[_c('img',{attrs:{"src":require("../refresh-arrow.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }